/**
 * Pendant zu `<SfCheckBox @bind-Checked=Model.Feld Label="…" Disabled=@(…ReadOnly) />`.
 * Kontrollkästchen tragen ihre Beschriftung neben dem Kästchen und geben keine
 * Validierungsmeldung aus.
 */

import { CheckBox } from '@/components/ui';

import { asFlag, type FieldAccess } from './fieldAccess';
import { FormField } from './FormField';

export interface CheckBoxFieldProps<T> {
  form: FieldAccess<T>;
  name: keyof T & string;
  label: string;
}

export function CheckBoxField<T>(props: CheckBoxFieldProps<T>) {
  const { form, name } = props;
  const field = form.viewField(name);
  if (field === null) return null;

  return (
    <FormField>
      <CheckBox
        checked={asFlag(form.value(name))}
        label={props.label}
        disabled={field.ReadOnly}
        onChange={(checked) => {
          form.setValue(name, checked);
        }}
      />
    </FormField>
  );
}

export default CheckBoxField;
